import { render, staticRenderFns } from "./BasicInput.vue?vue&type=template&id=8e89a2ca"
import script from "./BasicInput.vue?vue&type=script&lang=js"
export * from "./BasicInput.vue?vue&type=script&lang=js"
import style0 from "./BasicInput.vue?vue&type=style&index=0&id=8e89a2ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports